import { ConfigFn } from '@config/types'

const config = (({ staticAssetPageUrl, staticPageUrlSuffix }) =>
  ({
    hearkenUrl: 'https://modules.wearehearken.eu/blick-ch/embed/{hearkenId}.js',
    widgetUrl: `${staticAssetPageUrl}/hearken${staticPageUrlSuffix}`,
  }) as const) satisfies ConfigFn

export default config
